import axiosRetry from 'axios-retry';
import axios from 'axios';
import { getEnvironmentConstant } from './utilities';
import { RETRY_COUNT, UGC_FILTER_API, UGC_FILTER_KEY } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const profanityFilter = ({ data, env }) => {
  axiosRetry(axios, { retries: RETRY_COUNT });
  if (!data || !env) {
    return Promise.reject(new Error('Missing data'));
  }

  return axios.post(getEnvironmentConstant({ key: UGC_FILTER_API, env }), { document: data }, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-api-key': getEnvironmentConstant({ key: UGC_FILTER_KEY, env }),
    },
  }).then((res) => res?.data?.results, (err) => Promise.reject(new Error(`Failed to get results from UGC filter: ${err}`)));
};
